import { useGamePreference } from "MVVM/Hooks/useGamePreference";

const GamePreferenceInitializer = () => {
  useGamePreference();
  return null;
};

export { GamePreferenceInitializer };
